module.exports = __webpack_public_path__ + "img/erp-logos_0039_businesscentral.362b2a33.jpg";